import { useContext, useEffect, useState } from 'react';
import dropToken from '../../functions/dropToken';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import Container from '../../components/Container';
import GlobalContext from '../../contexts/GlobalContext';
import GlobalContextI from '../../interfaces/GlobalContext';
import AllAccessCheckIn from '../../img/allaccesscheckin.svg';
import CheckInIcon from '../../img/checkin.svg';
import UsersIcon from '../../img/users.svg';
import KioskEmployeePunchModal from '../../components/modals/KioskEmployeePunchModal';
import KioskSaleModal, {
    SaleItem as SaleItemPayload,
} from '../../components/modals/KioskSaleModal';
import { iconForItem } from '../../img/sales';
import DarkModeToggle from '../../components/DarkModeToggle';
import { setCheckInOrigin } from '../../functions/checkInOrigin';
// 2026-05-24: import retained but commented — see disabled mount below.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import TimeClockReminderPopup from '../../components/TimeClockReminderPopup';

interface SaleItemDoc {
    _id: string;
    name: string;
    price: number;
    sortOrder: number;
    active: boolean;
}

const KioskPage = () => {
    const history = useHistory();
    const { user, setUser } = useContext<GlobalContextI>(GlobalContext);
    const isAdmin = user?.accessLevel === 3;
    const handleLogOut = async () => await dropToken(setUser!, history);
    const [punchOpen, setPunchOpen] = useState(false);
    const [saleOpen, setSaleOpen] = useState(false);
    const [activeSale, setActiveSale] = useState<SaleItemPayload | null>(null);
    const [items, setItems] = useState<SaleItemDoc[] | null>(null);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await axios.get<SaleItemDoc[]>(
                    '/api/sales-items?activeOnly=true'
                );
                setItems(data);
            } catch (e: any) {
                setError(e?.response?.data?.message || 'Failed to load items.');
            }
        })();
    }, []);

    const tapSale = (item: SaleItemDoc) => {
        setActiveSale({ name: item.name, price: item.price });
        setSaleOpen(true);
    };

    return (
        <Container containerName={'dashboard'}>
            <DarkModeToggle
                style={{ position: 'fixed', top: '2rem', left: '2rem', zIndex: 5 }}
            />
            <div className="button-container">
                <label className="label-block">
                    <button
                        className="label-block__button"
                        onClick={() => {
                            setCheckInOrigin('kiosk');
                            history.push('/guests/checkin/allAccess');
                        }}
                    >
                        <img
                            className="button-icon"
                            src={AllAccessCheckIn}
                            alt="All Access guest Icon"
                        />
                    </button>
                    All-Access Guest
                </label>
                <label className="label-block">
                    <button
                        className="label-block__button"
                        onClick={() => {
                            setCheckInOrigin('kiosk');
                            history.push('/guests/checkin/limited');
                        }}
                    >
                        <img
                            className="button-icon"
                            src={CheckInIcon}
                            alt="Limited guest Icon"
                        />
                    </button>
                    Guest Check-In
                </label>
            </div>

            {error && (
                <h3 className="transaction-container__text">
                    <span className="red-span">{error}</span>
                </h3>
            )}

            {items && (
                <div className="button-container">
                    {items.map((item) => {
                        const icon = iconForItem(item.name);
                        return (
                            <label className="label-block" key={item._id}>
                                <button
                                    className="label-block__button"
                                    onClick={() => tapSale(item)}
                                >
                                    {icon ? (
                                        <img
                                            className="button-icon"
                                            src={icon}
                                            alt={item.name}
                                            style={{
                                                maxWidth: '100%',
                                                height: '7.5rem',
                                                width: 'auto',
                                                objectFit: 'contain',
                                            }}
                                        />
                                    ) : (
                                        <div
                                            className="button-icon"
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontSize: '3rem',
                                                fontWeight: 700,
                                                color: '#9B3737',
                                            }}
                                        >
                                            ${item.price}
                                        </div>
                                    )}
                                </button>
                                {item.name} — ${item.price}
                            </label>
                        );
                    })}
                    <label className="label-block">
                        <button
                            className="label-block__button"
                            onClick={() => history.push('/sacrifice')}
                        >
                            <div
                                className="button-icon"
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '4rem',
                                }}
                            >
                                🔥
                            </div>
                        </button>
                        Sacrifice
                    </label>
                </div>
            )}

            <button
                className="red-button margin"
                onClick={handleLogOut}
                style={{
                    position: 'fixed',
                    bottom: '2rem',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: 5,
                }}
            >
                Log Out
            </button>
            {isAdmin && (
                <label
                    className="label-block"
                    style={{
                        position: 'fixed',
                        top: '2rem',
                        right: '2rem',
                    }}
                >
                    <button
                        className="label-block__button"
                        onClick={() => history.push('/dashboard')}
                    >
                        <img
                            className="button-icon"
                            src={UsersIcon}
                            alt="Admin"
                        />
                    </button>
                    Admin
                </label>
            )}

            <label
                className="label-block"
                style={{ position: 'fixed', bottom: '2rem', left: '2rem' }}
            >
                <button
                    className="label-block__button"
                    onClick={() => history.push('/sso-roster')}
                >
                    <img
                        className="button-icon"
                        src={AllAccessCheckIn}
                        alt="Who's here"
                    />
                </button>
                Who's here
            </label>

            <label
                className="label-block"
                style={{ position: 'fixed', bottom: '2rem', right: '2rem' }}
            >
                <button
                    className="label-block__button"
                    onClick={() => setPunchOpen(true)}
                >
                    <img
                        className="button-icon"
                        src={UsersIcon}
                        alt="Employee Clock In"
                    />
                </button>
                Employee Clock In
            </label>

            <KioskEmployeePunchModal
                isOpen={punchOpen}
                setIsOpen={setPunchOpen}
            />
            <KioskSaleModal
                item={activeSale}
                isOpen={saleOpen}
                setIsOpen={setSaleOpen}
            />
        {/* 2026-05-24: TimeClockReminderPopup disabled per operator request — annoying during service.
            Re-enable by removing this comment wrapper. */}
        {/* <TimeClockReminderPopup /> */}
            </Container>
    );
};

export default KioskPage;
